import React, { useState } from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';

import { useTranslation } from 'next-i18next';
import WrappedButton from '../WrappedButton';
interface SimplePaginationProps {
  totalPage: number;
  currentPage: number;
  loading?: boolean;
  onChange: (data: { newPage: number; action: 'prev' | 'next' }) => void;
}

export const SimplePagination: React.FC<SimplePaginationProps> = ({
  totalPage,
  currentPage,
  onChange,
  loading = false,
}) => {
  const [t] = useTranslation();
  const handlePrev = () => {
    if (!loading) {
      const newPage = Math.max(currentPage - 1, 0);
      onChange({
        newPage,
        action: 'prev',
      });
    }
  };

  const handleNext = () => {
    const newPage = currentPage + 1;
    onChange({
      newPage,
      action: 'next',
    });
  };
  const noNext = currentPage + 1 == totalPage || loading;
  const noPrev = currentPage == 0 || loading;

  return (
    <Stack
      sx={{
        width: '100%',
      }}
      direction="row"
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <Stack direction="row">
        showing 1-{totalPage} of
        <Box
          sx={{
            ml: 1,
          }}
          component="span"
        >
          {currentPage + 1}
        </Box>
      </Stack>
      <Stack direction="row" spacing={1} alignItems={'center'}>
        <WrappedButton
          variant={'plain'}
          color="secondary"
          onClick={handlePrev}
          sx={{
            opacity: noPrev ? 0.5 : 1,
          }}
          disabled={noPrev}
        >
          {t('Previous')}
        </WrappedButton>
        {loading ? <CircularProgress size={20} /> : <></>}
        <WrappedButton
          variant={'plain'}
          color="secondary"
          onClick={handleNext}
          sx={{
            opacity: noNext ? 0.5 : 1,
          }}
          disabled={noNext}
        >
          {t('Next')}
        </WrappedButton>
      </Stack>
    </Stack>
  );
};
